import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
const MoveFolderHoverButton = ({
  hasMovePermission = true,
  onClick
}) => {
  const handleMoveClick = () => {
    if (onClick) {
      onClick();
    }
  };
  return /*#__PURE__*/_jsx(Button, {
    disabled: !hasMovePermission,
    onClick: handleMoveClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "salesContentIndexUI.tableRowHoverButtons.move"
    })
  }, "move");
};
export default MoveFolderHoverButton;